import React from 'react';
import { Helmet } from 'react-helmet';
import useBotPagesConfig from '../../hooks/useBotPagesConfig';

interface DocumentHeadProps {
    title?: string;
    description?: string;
    hideServerHeaders?: boolean;
}

const DocumentHead: React.FC<DocumentHeadProps> = ({
    title,
    description,
    hideServerHeaders = false
}) => {
    const { title: configTitle, styles } = useBotPagesConfig();

    const fullTitle = title ? `${configTitle} ${title}` : configTitle;

    if (hideServerHeaders) {
        return (
            <Helmet>
                <title>{fullTitle}</title>
                <meta property='og:site_name' content='Help pages' />{' '}
            </Helmet>
        );
    }
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta property='og:site_name' content='Help pages' />
            <meta property='test' content='Help pages' />

            <meta name='description' content={description} />
            {/* react-helmet stringifies each child's type, so it cannot take a
                Fragment here (its type is a Symbol). Gate each meta individually. */}
            <meta name='og:title' property='og:title' content={fullTitle} />
            <meta property='og:type' content='website' />
            <meta property='og:description' content={description} />
            <meta property='og:image' content={styles?.logoUrl} />
        </Helmet>
    );
};

export default DocumentHead;
